// extracted by mini-css-extract-plugin
export default {"customerTypeContainer":"documentPaymentTypeIdsFields_customerTypeContainer__tmaH0","customerTypeId":"documentPaymentTypeIdsFields_customerTypeId__AA7+u"};